import { useEntity } from '@backstage/plugin-catalog-react';
import { InfoCard, StatusOK, StatusWarning } from '@backstage/core-components';
import { Tooltip } from '@material-ui/core';
import { ACCOUNT_ENABLED_ANNOTATION } from './constant.tsx';

export function UserAccountStatusCard() {
  const { entity } = useEntity();
  const enabled =
    entity.metadata.annotations?.[ACCOUNT_ENABLED_ANNOTATION] !== 'false';

  return (
    <InfoCard title="Account Status">
      <Tooltip
        title={
          enabled
            ? 'Microsoft Entra account is active'
            : 'Microsoft Entra account is inactive'
        }
      >
        <span
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            fontSize: 14,
          }}
        >
          {enabled ? (
            <>
              <StatusOK /> <strong>Active</strong>
            </>
          ) : (
            <>
              <StatusWarning /> <strong>Inactive</strong>
            </>
          )}
        </span>
      </Tooltip>
    </InfoCard>
  );
}

